// src/utils/topicMerge.js
//
// Small shared rules for how topic content from different tiers is shown.
// Used by TopicView (what members see) and the CMS (ResourceManager,
// AdminPortal) so the manager's preview order matches the app.

// Resources added through the CMS with "Place at: top" carry `pinned: true`.
// Additive tiers (vertical packs, private org content) are unioned AFTER the
// base resources of a module, so pinning is how an added intro video reaches
// the top of an existing module. Stable: pinned items keep their own order.
export const pinnedFirst = (resources = []) => {
    const pinned = resources.filter(r => r && r.pinned);
    if (pinned.length === 0) return resources;
    return [...pinned, ...resources.filter(r => !(r && r.pinned))];
};

// Modules added through the CMS with "Pin to top" carry `pinned: true`. Pack /
// private modules are unioned AFTER the base modules, so pinning is how an
// added intro module reaches the top of a topic. Stable.
export const pinnedModulesFirst = (modules = []) => {
    const pinned = modules.filter(m => m && m.pinned);
    if (pinned.length === 0) return modules;
    return [...pinned, ...modules.filter(m => !(m && m.pinned))];
};

// A shared topic doc written by the CMS carries `managed: true`: its module
// list IS the shared content (order and deletions honoured), and the
// hardcoded base in content.js is no longer merged underneath it.
export const isManagedTopic = (sharedDoc) => !!(sharedDoc && sharedDoc.managed && Array.isArray(sharedDoc.modules));
